/* eslint-disable no-shadow */
import React, { Fragment, FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { detect } from "detect-browser";
import Button from "../../shared/button/Button";
import {
  Field,
  TextInput,
  Error,
  ButtonsWrapper,
  StepCount,
} from "../styles/review-styles";

interface IMessageProps {
  setReviewMessage: (event) => void;
  reviewMessage: string;
  messageError?: {
    message?: {
      fullMessage?: string;
    };
  };
}

export const Message: FunctionComponent<IMessageProps> = ({
  setReviewMessage,
  reviewMessage,
  messageError,
}) => {
  const iOS = detect().name === "ios";

  return (
    <Fragment>
      <Field className="animated fadeInDown delay">
        <TextInput
          placeholder="Enter your message..."
          value={reviewMessage}
          onChange={setReviewMessage}
        />
        {messageError && <Error>{messageError.message.fullMessage}</Error>}
      </Field>
      <ButtonsWrapper className="animated fadeInDown delay">
        <Button primary iOS={iOS} buttonName="Submit" type="submit" />
      </ButtonsWrapper>
      <StepCount>step 5 of 5</StepCount>
    </Fragment>
  );
};

Message.propTypes = {
  setReviewMessage: PropTypes.func.isRequired,
  reviewMessage: PropTypes.string.isRequired,
  messageError: PropTypes.shape({
    message: PropTypes.shape({ fullMessage: PropTypes.string }),
  }),
};

Message.defaultProps = {
  messageError: null,
};

interface IReduxState {
  employerPendingReviews: {
    errors: unknown;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  messageError: state.employerPendingReviews.errors,
});

export default connect(mapStateToProps, {})(Message);
